import { useAuth } from './useAuth'

/**
 * Hook to check if user needs onboarding
 * Returns true if user has an agency but no residences yet
 */
export function useOnboardingStatus() {
  const { data: auth, isLoading } = useAuth()

  if (isLoading || !auth) {
    return {
      needsOnboarding: false,
      isLoading,
      hasAgency: false,
      hasResidences: false,
    }
  }

  const hasAgency = !!auth.profile?.agency_id
  const hasResidences = auth.residences.length > 0

  // User needs onboarding if they have an agency but no residences
  const needsOnboarding = hasAgency && !hasResidences

  console.log('🔍 [useOnboardingStatus]', {
    hasAgency,
    hasResidences,
    residencesCount: auth.residences.length,
    needsOnboarding,
    profile: auth.profile,
    residences: auth.residences,
  })

  return {
    needsOnboarding,
    isLoading,
    hasAgency,
    hasResidences,
  }
}
